import { injectable, inject } from 'inversify';
import type { ISupportTicketRepository, SupportTicketDTO, UpdateTicketDTO } from '@/domain/repositories/ISupportTicketRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class UpdateTicketAction {
  constructor(
    @inject(TYPES.ISupportTicketRepository) private repo: ISupportTicketRepository
  ) {}

  async execute(id: string, data: UpdateTicketDTO): Promise<SupportTicketDTO> {
    return this.repo.update(id, data);
  }
}
